import apiClient from '@/axios/app-client';

const ROLES_ENDPOINT = 'v1/roles';

export interface SyncOidcRolesResponse {
  success: boolean;
  message: string;
  data: {
    syncedCount: number;
  };
}

/**
 * Sync OIDC roles to local roles table
 * This endpoint fetches all roles from OIDC API and updates oidc_role_id
 * in the local roles table by matching role names
 */
export const syncOidcRoles = async (): Promise<SyncOidcRolesResponse> => {
  const response = await apiClient.post<SyncOidcRolesResponse>(`${ROLES_ENDPOINT}/sync-oidc`);
  return response.data.data;
};
